/*---------------------------------------------------------------------------------------------
 *  Copyright (c) i-Bridge Systems Philippines Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
import { ConfirmationModal, SuccessModal } from '../index';
import { useState } from 'react';
import { apiUrl } from '../../utilities/apiUrl';
import { Cancel } from '@mui/icons-material';
import { Box, Typography, CircularProgress } from '@mui/material';

export const ConfirmRejectRequestModal = (props) => {
  const [rejectSuccessOpen, setRejectSuccessOpen] = useState(false);
  const [requestLoading, setRequestLoading] = useState(false);

  const handleEditRequestAction = async () => {
    setRequestLoading(true);
    const action = 'rejected';
    const url = apiUrl(`/eis/empeditrequest/action/${action}`);
    try {
      const response = await fetch(url, {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          editReqId: props.editRequest._id,
          empid: props.editRequest.empid,
        }),
      });

      if (!response.ok) {
        console.error(`Error updating edit request:`, response.statusText);
        return null;
      }

      //const data = await response.json();
      setRejectSuccessOpen(true);
      await props.fetchEditRequestData();
    } catch (err) {
      console.error(`Error fetching`, err);
    }
    props.setRequestModal(false);
    setRequestLoading(false);
  };

  return (
    <>
      <ConfirmationModal
        open={props.open}
        onClose={props.onClose}
        primaryClickHandler={async () => {
          await handleEditRequestAction();
          props.onClose();
        }}
        secondaryClickHandler={props.onClose}
        title={
          <Box display="flex" alignItems="center" gap={1}>
            <Cancel sx={{ fontSize: 30 }} />
            <Typography variant="h6" fontWeight={600} sx={{ color: '#d32f2f' }}>
              Reject Edit Request
            </Typography>
          </Box>
        }
        desc={
          requestLoading ? (
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                width: '100%',
                mt: 7,
              }}
            >
              <CircularProgress />
            </Box>
          ) : (
            <Box>
              <Typography variant="body1" sx={{ mt: 3, mb: 2 }}>
                Are you sure you want to reject this request?
              </Typography>
              <Typography variant="body2" color="text.secondary">
                This action cannot be undone and the employee's data will not be
                updated.
              </Typography>
            </Box>
          )
        }
        primaryBtnName={'Reject'}
        secondaryBtnName={requestLoading ? null : 'Cancel'}
        primaryStyle={{
          bgcolor: '#d32f2f',
          border: '1px solid #d32f2f',
          '&:hover': {
            bgcolor: '#b71c1c !important',
            borderColor: '#b71c1c',
          },
          ...(requestLoading && { visibility: 'hidden' }),
        }}
        secondaryStyle={{
          ...(requestLoading && { visibility: 'hidden' }),
        }}
      />
      <SuccessModal
        open={rejectSuccessOpen}
        onClose={() => {
          setRejectSuccessOpen(false);
          props.onSuccess();
        }}
        close={() => {
          setRejectSuccessOpen(false);
          props.onSuccess();
        }}
        desc={'You have successfully rejected an edit request.'}
      />
    </>
  );
};
